import type { BangKeChungTuItem } from '@/types/schemas';
import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface BangKeChungTuResponse<T = BangKeChungTuItem> {
  results: T[];
  count: number;
  next?: string | null;
}

export const fetchAllBangKeChungTu = async (
  entitySlug: string,
  body: Record<string, any> = {},
  pageSize = 200
): Promise<BangKeChungTuItem[]> => {
  let page = 1;
  let all: BangKeChungTuItem[] = [];
  let totalCount = 0;

  while (true) {
    const response = await api.post<BangKeChungTuResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.BANG_KE_CHUNG_TU}/`,
      body,
      {
        params: {
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    totalCount = response.data.count ?? totalCount;
    all = all.concat(pageResults);

    if (!pageResults.length) {
      break;
    }

    const hasNext = (response.data as any).next;

    if (!hasNext && pageResults.length < pageSize) {
      break;
    }

    if (totalCount && all.length >= totalCount) {
      break;
    }

    page += 1;
  }

  return all;
};
